"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
exports.useOwnTasks = void 0;
var react_1 = __importDefault(require("react"));
var main_1 = require("@hiyllo/react-data/main");
var omni_continuity_1 = require("@hiyllo/omni-continuity");
var ListOwnTasksBP = __importStar(require("@hiyllo/omni-common/src/blueprints/tasks/list-own-tasks"));
var SetIcTasksOrderBP = __importStar(require("@hiyllo/omni-common/src/blueprints/tasks/set-ic-tasks-order"));
var GetICTasksOrderBP = __importStar(require("@hiyllo/omni-common/src/blueprints/tasks/get-ic-tasks-order"));
var ICUserTasksPSB = __importStar(require("@hiyllo/omni-common/src/blueprints/tasks/pubsub/ic-user-tasks"));
var use_dnd_on_drag_end_1 = require("./use-dnd-on-drag-end");
var use_order_1 = require("./use-order");
function useOwnTasks(opts, self) {
    var _a;
    var _b = react_1["default"].useState(null), order = _b[0], setOrder = _b[1];
    var client = (0, omni_continuity_1.useClient)();
    var cache = (0, omni_continuity_1.useCache)();
    var Tenant = (0, omni_continuity_1.useTenant)();
    var setICTasksOrderMutation = client.useMutation(SetIcTasksOrderBP);
    var getICTasksOrderMutation = client.useMutation(GetICTasksOrderBP);
    var tasks = (0, main_1.useMultipleDocuments)(client, {
        cache: cache,
        key: "tasks.ic.tasklist/".concat(self.userId, "/").concat((_a = opts.filter) !== null && _a !== void 0 ? _a : "all"),
        subscription: {
            blueprint: ICUserTasksPSB,
            topic: "[".concat(Tenant, "]ic-user-tasks/").concat(self.userId)
        },
        query: {
            blueprint: ListOwnTasksBP,
            params: {
                filter: opts.filter
            },
            mapperFn: function (res) { return res.tasks; },
            mode: "overwrite"
        },
        keyExtractorFn: function (task) { return task.uuid; }
    });
    react_1["default"].useEffect(function () {
        void cache.get("tasks/ic-view/order").then(function (cachedOrder) {
            setOrder(function (current) { return (current === null ? cachedOrder !== null && cachedOrder !== void 0 ? cachedOrder : {} : current); });
            getICTasksOrderMutation.call(null).then(function (_a) {
                var order = _a.order;
                setOrder(function (current) { return (current === null || current === cachedOrder ? order !== null && order !== void 0 ? order : {} : current); });
            });
        });
    }, []);
    var onChangeOrder = react_1["default"].useCallback(function (newOrder, updatedTask) {
        void cache.set("tasks/ic-view/order", newOrder);
        void setICTasksOrderMutation.call({ order: newOrder });
        setOrder(newOrder);
        if (updatedTask !== null) {
            tasks._ingest([updatedTask], false);
        }
    }, []);
    var ensuredOrder = (0, use_order_1.useOrder)(order !== null && order !== void 0 ? order : {}, tasks.data);
    var onDragEnd = (0, use_dnd_on_drag_end_1.useDNDOnDragEnd)({
        order: ensuredOrder,
        tasks: tasks.data,
        onChangeOrder: onChangeOrder
    });
    return {
        tasks: tasks,
        order: order,
        onChangeOrder: onChangeOrder,
        onDragEnd: onDragEnd
    };
}
exports.useOwnTasks = useOwnTasks;
